module.exports = __webpack_public_path__ + "media/assets/plane-12-color-2464b94cc6a9fd613073668b95ac849a.svg";